var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback } from 'react';
import { isNil } from '../util';
/**
 * Translate hook that will take the user provided translates (typically from a translate prop)
 * and merge them with the default translations. This will result in the full dictionary of
 * localized strings that can be used within a component.
 */
export function useTranslate(userProvidedTranslations, defaultTranslations) {
    return useCallback(function (key) {
        var _a;
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        // Check for a user provided translation and then fallback to the default
        var translation = (_a = userProvidedTranslations === null || userProvidedTranslations === void 0 ? void 0 : userProvidedTranslations[key]) !== null && _a !== void 0 ? _a : defaultTranslations === null || defaultTranslations === void 0 ? void 0 : defaultTranslations[key];
        if (!isNil(translation)) {
            if (typeof translation === 'function') {
                return translation.apply(void 0, __spreadArray([], __read(rest), false));
            }
            return translation;
        }
        // If no translation was found, return the key
        return key;
    }, [defaultTranslations, userProvidedTranslations]);
}
//# sourceMappingURL=useTranslate.js.map